import { render, staticRenderFns } from "./ResizeColumnButton.vue?vue&type=template&id=bfe5a746"
import script from "./ResizeColumnButton.vue?vue&type=script&lang=js"
export * from "./ResizeColumnButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfe5a746')) {
      api.createRecord('bfe5a746', component.options)
    } else {
      api.reload('bfe5a746', component.options)
    }
    module.hot.accept("./ResizeColumnButton.vue?vue&type=template&id=bfe5a746", function () {
      api.rerender('bfe5a746', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/clients/components/ResizeColumnButton.vue"
export default component.exports